import { faLaptop } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Grid from '@material-ui/core/Grid';
import React, { Component } from 'react';
import "../../../style";





class FeatureFour extends Component {
    render(){
        return(
            <Grid item sm={3} xs={12}>
                <div className="featureCard">
                    <div className="featureIcon">
                        <FontAwesomeIcon icon={faLaptop} className="featureSvg"/>
                    </div>
                    <h3 className="CardHead">Access Anywhere</h3>
                    <p className="cardDescription">
                    Access and sync data in
the field or back at the
office and define each
user’s data view                    </p>
            </div>
            </Grid>
        );
    }
}

export default FeatureFour;


// WEBPACK FOOTER //
// ./src/components/public/Home/FeatureFour.js